import {Component} from "xm-ui";
import {ISpinnerOptions} from "./ISpinnerOptions";

import * as spinnerStyles from "../assets/spinner.css";

export class SpinnerComponent extends Component<ISpinnerOptions> {
    public async render(childNodes: Promise<JQuery>[]) {
        return (
            <div class="spinner">
                <style>{this.options.styles}</style>
                <div class="spinner-rect spinner-rect1"/>
                <div class="spinner-rect spinner-rect2"/>
                <div class="spinner-rect spinner-rect3"/>
                <div class="spinner-rect spinner-rect4"/>
                <div class="spinner-rect spinner-rect5"/>
            </div>
        );
    }

    protected getDefaultOptions(): Partial<ISpinnerOptions> {
        return $.extend(super.getDefaultOptions(), {
            styles: spinnerStyles
        });
    }
}



// WEBPACK FOOTER //
// ./components/SpinnerComponent.tsx